import React from 'react';

function BlueSvg() {
  return (
    <svg
      width="300"
      height="201"
      viewBox="0 0 300 201"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_1234)">
        <path d="M300 0H0V201H300V0Z" fill="#CCEFF6" />
        <path
          d="M221.472 70.3962V74.4328H165.124V70.3962H221.472ZM176.115 72.5819C176.115 72.3953 176.06 72.2131 175.957 72.0581C175.854 71.9031 175.708 71.7823 175.538 71.7109C175.367 71.6395 175.179 71.621 174.998 71.6573C174.817 71.6937 174.65 71.7835 174.52 71.9156C174.389 72.0474 174.3 72.2156 174.264 72.3984C174.228 72.5813 174.246 72.771 174.317 72.9432C174.388 73.1157 174.507 73.2628 174.661 73.3668C174.814 73.4704 174.995 73.5258 175.18 73.5261C175.303 73.5268 175.426 73.5027 175.54 73.4554C175.654 73.4081 175.758 73.3383 175.845 73.25C175.932 73.162 176.001 73.0575 176.048 72.9422C176.095 72.827 176.119 72.7034 176.118 72.5787L176.115 72.5819ZM172.437 72.5819C172.437 72.3953 172.382 72.2131 172.279 72.0581C172.176 71.9031 172.03 71.7823 171.86 71.7109C171.689 71.6395 171.501 71.621 171.32 71.6573C171.139 71.6937 170.973 71.7835 170.842 71.9153C170.711 72.0471 170.622 72.2149 170.586 72.3978C170.55 72.5806 170.568 72.7704 170.638 72.9429C170.709 73.1151 170.828 73.2625 170.982 73.3665C171.135 73.4701 171.316 73.5258 171.501 73.5261C171.624 73.5268 171.747 73.5027 171.861 73.4554C171.975 73.4081 172.079 73.3383 172.166 73.2503C172.253 73.162 172.323 73.0575 172.369 72.9422C172.416 72.827 172.44 72.7034 172.44 72.5787L172.437 72.5819ZM168.758 72.5819C168.758 72.3953 168.703 72.2131 168.6 72.0581C168.497 71.9031 168.351 71.7823 168.18 71.7109C168.01 71.6395 167.822 71.621 167.641 71.6573C167.459 71.6937 167.293 71.7835 167.163 71.9156C167.032 72.0474 166.943 72.2156 166.907 72.3984C166.871 72.5813 166.889 72.771 166.96 72.9432C167.03 73.1157 167.15 73.2628 167.303 73.3668C167.457 73.4704 167.638 73.5258 167.823 73.5261C167.946 73.5271 168.068 73.5033 168.183 73.456C168.298 73.4087 168.402 73.3392 168.489 73.2509C168.577 73.163 168.646 73.0581 168.693 72.9426C168.74 72.8273 168.764 72.7037 168.763 72.5787L168.758 72.5819Z"
          fill="#006B99"
        />
        <path
          d="M210.236 154.746H148.748L141.015 149.218L117.883 132.683L117.917 132.526C118.249 132.63 118.594 132.683 118.942 132.683H176.975C177.585 132.683 178.185 132.521 178.712 132.211L210.236 154.746ZM176.751 146.268H193.291L188.432 142.795L177.64 135.078H127.717L132.042 138.171L143.368 146.268H176.751ZM163.261 152.625H187.26L181.277 148.348H157.218L163.201 152.625H163.261Z"
          fill="#CCEFF6"
        />
        <path
          d="M193.29 146.268H176.751V146.17L172.242 142.947H188.327L188.431 142.796L193.29 146.268Z"
          fill="#CCEFF6"
        />
        <path
          d="M150.432 138.171L146.107 135.078H177.639L188.431 142.795L188.327 142.947H172.242L176.751 146.17V146.268H143.364L132.038 138.171H150.432Z"
          fill="#CCEFF6"
        />
        <path
          d="M187.26 152.625H163.261H163.2L157.217 148.348H181.216H181.277L187.26 152.625Z"
          fill="#F7CEDC"
        />
        <path
          d="M180.428 108.343V129.2C180.428 129.658 180.338 130.111 180.165 130.534C179.991 130.956 179.737 131.34 179.416 131.664C179.096 131.987 178.715 132.244 178.296 132.419C177.877 132.594 177.428 132.683 176.975 132.683H118.942C118.488 132.683 118.04 132.593 117.621 132.418C117.202 132.243 116.822 131.987 116.501 131.663C116.181 131.34 115.927 130.956 115.753 130.533C115.58 130.11 115.491 129.657 115.492 129.2V87.4888C115.492 86.5646 115.855 85.6786 116.502 85.0252C117.149 84.3718 118.027 84.0045 118.942 84.0039H176.975C177.428 84.0039 177.877 84.0938 178.296 84.2691C178.715 84.4441 179.096 84.7008 179.417 85.0246C179.738 85.3483 179.992 85.7328 180.165 86.1557C180.339 86.579 180.428 87.0324 180.428 87.4901V108.343ZM177.8 127.295V89.3908C177.8 88.6648 177.514 87.9688 177.006 87.4557C176.498 86.9422 175.808 86.6542 175.089 86.6542H120.828C120.109 86.6542 119.419 86.9422 118.911 87.4557C118.403 87.9688 118.117 88.6648 118.117 89.3908V127.295C118.117 128.02 118.403 128.717 118.911 129.23C119.419 129.743 120.109 130.031 120.828 130.031H175.088C175.808 130.031 176.497 129.743 177.005 129.23C177.514 128.717 177.799 128.02 177.799 127.295H177.8Z"
          fill="#CCEFF6"
        />
        <path
          d="M177.799 89.3909V101.108H177.284V100.911C177.284 97.5667 175.418 95.9321 173.138 95.9321H172.894C172.746 95.9324 172.605 95.8736 172.501 95.7687C172.396 95.6638 172.337 95.5214 172.337 95.3726V94.4894C172.693 94.3116 172.994 94.0367 173.205 93.6955C173.415 93.3542 173.527 92.9603 173.527 92.5587V91.3589C173.527 90.7875 173.302 90.2396 172.902 89.8354C172.502 89.4316 171.959 89.2046 171.393 89.2046C170.827 89.2046 170.284 89.4316 169.884 89.8354C169.484 90.2396 169.259 90.7875 169.259 91.3589V92.5587C169.259 92.9603 169.371 93.3542 169.581 93.6955C169.792 94.0367 170.093 94.3116 170.449 94.4894V95.3758C170.449 95.5242 170.391 95.666 170.287 95.7712C170.183 95.877 170.041 95.9375 169.893 95.939C169.258 95.9174 168.626 96.0295 168.037 96.2681C167.448 96.507 166.914 96.867 166.47 97.3257C166.026 97.784 165.682 98.331 165.459 98.9315C165.237 99.532 165.14 100.173 165.176 100.813H165.124V86.6558H175.089C175.807 86.6558 176.497 86.9438 177.005 87.4566C177.513 87.9695 177.799 88.6651 177.799 89.3909Z"
          fill="#F7CEDC"
        />
        <path
          d="M177.222 128.815L177.338 128.823C177.09 129.195 176.755 129.499 176.363 129.71C175.972 129.92 175.535 130.03 175.091 130.03H165.124V129.726H165.176C165.14 129.085 165.237 128.445 165.459 127.844C165.682 127.244 166.026 126.697 166.47 126.239C166.914 125.78 167.448 125.42 168.037 125.181C168.626 124.942 169.258 124.83 169.893 124.852C169.966 124.852 170.038 124.838 170.106 124.81C170.173 124.782 170.235 124.741 170.287 124.689C170.338 124.637 170.379 124.575 170.408 124.507C170.436 124.439 170.45 124.366 170.45 124.292V123.406C170.093 123.229 169.793 122.953 169.582 122.612C169.372 122.271 169.26 121.877 169.26 121.475V120.276C169.26 119.705 169.485 119.157 169.885 118.753C170.285 118.349 170.828 118.122 171.394 118.122C171.96 118.122 172.503 118.349 172.903 118.753C173.303 119.157 173.528 119.705 173.528 120.276V121.475C173.528 121.877 173.416 122.271 173.206 122.612C172.995 122.953 172.694 123.229 172.337 123.406V124.294C172.338 124.443 172.397 124.585 172.501 124.69C172.606 124.795 172.747 124.854 172.894 124.853H173.138C175.175 124.851 176.88 126.157 177.222 128.815Z"
          fill="#006B99"
        />
        <path
          d="M177.285 115.24V115.524H165.124V115.134H165.176C165.14 114.494 165.237 113.853 165.459 113.253C165.682 112.652 166.027 112.105 166.47 111.647C166.914 111.189 167.448 110.828 168.037 110.59C168.626 110.351 169.258 110.239 169.893 110.261C170.041 110.261 170.183 110.201 170.288 110.096C170.392 109.991 170.45 109.849 170.45 109.701V108.815C170.093 108.637 169.792 108.362 169.582 108.021C169.372 107.679 169.26 107.285 169.26 106.883V105.684C169.26 105.113 169.485 104.565 169.885 104.161C170.285 103.757 170.828 103.53 171.394 103.53C171.96 103.53 172.503 103.757 172.903 104.161C173.303 104.565 173.528 105.113 173.528 105.684V106.886C173.528 107.288 173.416 107.682 173.206 108.023C172.995 108.364 172.694 108.64 172.337 108.817V109.698C172.338 109.847 172.397 109.99 172.501 110.094C172.606 110.2 172.747 110.259 172.894 110.259H173.138C175.419 110.261 177.285 111.898 177.285 115.24Z"
          fill="#006B99"
        />
        <path
          d="M177.285 100.914V101.111H165.124V100.807H165.176C165.141 100.168 165.238 99.5274 165.461 98.9278C165.684 98.3279 166.028 97.7816 166.472 97.3236C166.916 96.8655 167.449 96.5061 168.038 96.2675C168.627 96.0293 169.259 95.9172 169.893 95.9388C170.041 95.9385 170.183 95.8796 170.288 95.7747C170.391 95.6699 170.45 95.5277 170.45 95.3793V94.4892C170.093 94.3117 169.793 94.0365 169.582 93.6952C169.372 93.354 169.26 92.9604 169.26 92.5584V91.3587C169.26 90.7873 169.485 90.2394 169.885 89.8355C170.285 89.4313 170.828 89.2043 171.394 89.2043C171.96 89.2043 172.503 89.4313 172.903 89.8355C173.303 90.2394 173.528 90.7873 173.528 91.3587V92.5584C173.528 92.9604 173.416 93.354 173.205 93.6952C172.995 94.0365 172.694 94.3117 172.337 94.4892V95.3755C172.338 95.5243 172.397 95.6667 172.501 95.7716C172.606 95.8765 172.747 95.9353 172.894 95.935H173.138C175.419 95.9388 177.285 97.5718 177.285 100.914Z"
          fill="#006B99"
        />
        <path
          d="M171.503 71.6372C171.688 71.6369 171.869 71.6917 172.023 71.7953C172.178 71.8986 172.298 72.0461 172.369 72.2183C172.44 72.3908 172.458 72.5808 172.423 72.764C172.387 72.9472 172.298 73.1153 172.167 73.2474C172.036 73.3795 171.869 73.4697 171.688 73.506C171.507 73.5423 171.318 73.5235 171.148 73.4522C170.977 73.3805 170.831 73.2593 170.728 73.104C170.626 72.9484 170.571 72.7659 170.571 72.5793C170.572 72.3294 170.67 72.0902 170.845 71.9137C171.019 71.7371 171.256 71.6378 171.503 71.6372Z"
          fill="#FFCEB6"
        />
        <path
          d="M167.825 71.6372C168.01 71.6369 168.191 71.692 168.345 71.7956C168.499 71.8993 168.619 72.0464 168.69 72.2189C168.761 72.3914 168.779 72.5812 168.743 72.7643C168.708 72.9475 168.618 73.1156 168.488 73.2477C168.357 73.3798 168.19 73.4697 168.009 73.506C167.828 73.5423 167.639 73.5235 167.469 73.4518C167.298 73.3805 167.152 73.2593 167.049 73.104C166.947 72.9484 166.892 72.7659 166.893 72.5793C166.893 72.3294 166.991 72.0899 167.166 71.9133C167.341 71.7368 167.578 71.6375 167.825 71.6372Z"
          fill="#CCEFF6"
        />
        <path
          d="M155.782 43.5989V47.6392H78.4056V43.5989H155.782ZM89.4031 45.7851C89.4028 45.5985 89.3481 45.4163 89.2453 45.2614C89.1425 45.1064 88.9966 44.9855 88.826 44.9141C88.655 44.8431 88.4672 44.8243 88.2863 44.8606C88.105 44.8972 87.9384 44.9871 87.8078 45.1189C87.6772 45.2507 87.5881 45.4188 87.5522 45.6017C87.516 45.7848 87.5344 45.9742 87.605 46.1468C87.676 46.319 87.7953 46.4664 87.9491 46.57C88.1025 46.6737 88.2831 46.7291 88.4678 46.7294C88.5906 46.7297 88.7125 46.7053 88.826 46.658C88.9397 46.6104 89.0428 46.5409 89.1297 46.4533C89.2166 46.3656 89.2853 46.2613 89.3322 46.1468C89.3791 46.0322 89.4031 45.9091 89.4031 45.7851ZM85.7247 45.7851C85.7247 45.5989 85.6697 45.4163 85.5669 45.2614C85.4644 45.1064 85.3185 44.9855 85.1478 44.9145C84.9772 44.8431 84.7894 44.8243 84.6081 44.8606C84.4269 44.8969 84.2606 44.9868 84.1297 45.1186C83.9991 45.2504 83.91 45.4185 83.8741 45.6014C83.8378 45.7842 83.8563 45.9736 83.9266 46.1461C83.9972 46.3186 84.1166 46.4658 84.27 46.5697C84.4235 46.6734 84.6041 46.7291 84.7888 46.7294C84.9119 46.7297 85.0335 46.7056 85.1472 46.658C85.261 46.6107 85.3641 46.5412 85.451 46.4536C85.5378 46.3659 85.6069 46.2617 85.6538 46.1471C85.701 46.0322 85.725 45.9094 85.7247 45.7851ZM82.0456 45.7851C82.0456 45.5985 81.9906 45.4163 81.8878 45.2614C81.785 45.1064 81.6391 44.9855 81.4685 44.9141C81.2978 44.8431 81.11 44.8243 80.9288 44.8606C80.7475 44.8972 80.5813 44.9871 80.4506 45.1189C80.3197 45.2507 80.2309 45.4188 80.1947 45.6017C80.1588 45.7848 80.1772 45.9742 80.2478 46.1468C80.3185 46.319 80.4381 46.4664 80.5916 46.57C80.7453 46.6737 80.9256 46.7291 81.1106 46.7294C81.2334 46.7297 81.355 46.7053 81.4688 46.658C81.5822 46.6104 81.6853 46.5409 81.7722 46.4533C81.8591 46.3656 81.9278 46.2613 81.975 46.1468C82.0219 46.0322 82.046 45.9091 82.0456 45.7851Z"
          fill="#006B99"
        />
        <path
          d="M153.115 101.878V103.732L151.297 102.82C151.483 102.508 151.753 102.255 152.073 102.088C152.395 101.922 152.755 101.849 153.115 101.878Z"
          fill="#FFCEB6"
        />
        <path
          d="M146.107 135.078L150.432 138.171H132.038L127.713 135.078H146.107Z"
          fill="#CCEFF6"
        />
        <path
          d="M137.909 64.1381C137.976 64.187 138.031 64.2496 138.072 64.3219C138.113 64.3942 138.139 64.4744 138.147 64.5574C138.155 64.6403 138.146 64.7242 138.12 64.8031C138.094 64.882 138.051 64.9547 137.995 65.016L136.339 66.7828L134.626 68.6071L131.405 72.0454L131.215 72.072C131.141 71.9903 131.056 71.9198 130.962 71.8622C130.757 71.7311 130.521 71.6562 130.277 71.645V71.6396L134.654 66.9074L137.138 64.2148C137.193 64.1554 137.259 64.1078 137.333 64.0752C137.407 64.043 137.487 64.0261 137.567 64.0264C137.69 64.0267 137.809 64.0658 137.909 64.1381Z"
          fill="#006B99"
        />
        <path
          d="M134.182 94.208L136.16 95.203C135.773 96.4156 134.181 96.0173 134.181 96.0173L134.182 94.208Z"
          fill="#FFCEB6"
        />
        <path
          d="M133.307 57.7465V59.6015L131.491 58.6892C131.678 58.3777 131.946 58.1247 132.267 57.9585C132.588 57.7919 132.948 57.7186 133.307 57.7465Z"
          fill="#FFCEB6"
        />
        <path
          d="M132.036 74.8444C132.319 75.6381 131.444 76.4409 131.444 76.4409C130.774 75.9766 129.395 76.6105 128.998 77.3692C127.793 77.2048 127.823 76.5708 128.245 75.974C128.533 75.5858 128.893 75.2571 129.304 75.0057C130.247 74.4334 131.752 74.0517 132.036 74.8444Z"
          fill="#FFCEB6"
        />
        <path
          d="M131.089 73.4252C132.162 74.0388 132.035 74.8444 132.035 74.8444C131.751 74.0517 130.246 74.4333 129.303 75.0041C128.892 75.2555 128.532 75.5842 128.244 75.9727L128.107 75.8791C127.997 75.8732 127.888 75.8563 127.781 75.829C126.893 75.6061 127.421 74.7943 127.458 74.7358C127.931 74.5545 128.378 74.3128 128.79 74.0166C128.909 73.9242 129.009 73.81 129.087 73.68L129.173 73.6929C129.173 73.6929 130.372 73.0141 131.089 73.4252Z"
          fill="#FFCEB6"
        />
        <path
          d="M128.998 77.3675C129.395 76.6073 130.774 75.9749 131.444 76.4392C132.114 76.9038 131.736 78.1687 130.149 79.9833C129.768 80.4877 129.281 80.8997 128.722 81.189C128.163 81.4786 127.547 81.638 126.919 81.6558L125.79 83.972V84.004H119.977V83.9736L122.402 78.7867L124.654 74.4536C124.799 74.2157 125.008 74.0235 125.256 73.8995C126.248 73.3607 127.321 72.9931 128.433 72.8118C128.553 72.804 128.674 72.8165 128.791 72.8491C128.872 72.8738 128.946 72.9177 129.007 72.9765C129.068 73.0354 129.115 73.1077 129.144 73.1882C129.173 73.2683 129.182 73.3544 129.173 73.4393C129.163 73.5241 129.134 73.6052 129.087 73.6769C129.01 73.8068 128.91 73.9211 128.791 74.0134C128.379 74.3096 127.931 74.5513 127.459 74.7326C127.314 74.7911 127.178 74.8469 127.057 74.8923L127.077 74.9502L123.326 78.9564C123.27 79.0175 123.227 79.0898 123.201 79.1687C123.175 79.2476 123.166 79.3312 123.174 79.4138C123.182 79.4965 123.207 79.5766 123.248 79.6486C123.29 79.721 123.345 79.7833 123.412 79.8321C123.512 79.9044 123.633 79.9433 123.756 79.9429C123.837 79.9429 123.916 79.9264 123.99 79.8938C124.064 79.8615 124.13 79.814 124.185 79.7545L127.687 76.0144L127.782 75.8259C127.888 75.8534 127.997 75.87 128.108 75.876L128.244 75.9696C127.823 76.5695 127.794 77.2035 128.998 77.3675Z"
          fill="#FFCEB6"
        />
        <path
          d="M131.216 72.0748C131.707 72.648 131.09 73.4251 131.09 73.4251C130.372 73.0137 129.177 73.6903 129.177 73.6903L129.09 73.6774C129.136 73.6061 129.166 73.5246 129.175 73.4398C129.185 73.355 129.175 73.2689 129.147 73.1887C129.118 73.1082 129.071 73.0359 129.009 72.9771C128.948 72.9182 128.874 72.8744 128.793 72.8496C128.677 72.8171 128.556 72.8046 128.436 72.8124C128.622 72.4783 128.888 72.1969 129.21 71.9937C129.532 71.7908 129.899 71.6724 130.278 71.6499C130.521 71.6612 130.757 71.736 130.963 71.8672C131.057 71.9242 131.142 71.994 131.216 72.0748Z"
          fill="#FFCEB6"
        />
        <path
          d="M130.964 129.725V130.029H120.828C120.388 130.03 119.954 129.922 119.565 129.715C119.176 129.508 118.843 129.208 118.595 128.841L118.634 128.814C118.976 126.154 120.681 124.851 122.715 124.851H122.962C123.109 124.851 123.25 124.792 123.354 124.687C123.458 124.582 123.516 124.44 123.516 124.291V123.405C123.159 123.227 122.859 122.952 122.649 122.611C122.439 122.269 122.328 121.876 122.329 121.474V120.275C122.323 119.989 122.374 119.704 122.479 119.438C122.584 119.172 122.741 118.93 122.939 118.726C123.138 118.521 123.375 118.359 123.636 118.248C123.898 118.137 124.178 118.08 124.462 118.08C124.746 118.08 125.027 118.137 125.288 118.248C125.55 118.359 125.787 118.521 125.985 118.726C126.184 118.93 126.34 119.172 126.445 119.438C126.55 119.704 126.601 119.989 126.596 120.275V121.474C126.596 121.876 126.484 122.27 126.274 122.611C126.064 122.952 125.763 123.227 125.406 123.405V124.294C125.406 124.443 125.465 124.585 125.568 124.69C125.672 124.794 125.813 124.854 125.96 124.854C126.595 124.832 127.227 124.943 127.817 125.182C128.407 125.421 128.941 125.781 129.385 126.239C129.829 126.698 130.174 127.245 130.397 127.845C130.62 128.446 130.716 129.087 130.68 129.727L130.964 129.725Z"
          fill="#006B99"
        />
        <path
          d="M130.964 115.524V129.725H130.681C130.717 129.085 130.62 128.444 130.398 127.843C130.174 127.242 129.83 126.695 129.386 126.237C128.942 125.778 128.408 125.418 127.818 125.18C127.228 124.941 126.596 124.829 125.961 124.851C125.814 124.851 125.673 124.792 125.569 124.687C125.465 124.582 125.407 124.44 125.407 124.292V123.406C125.764 123.228 126.064 122.953 126.275 122.612C126.485 122.27 126.597 121.876 126.597 121.474V120.276C126.586 119.711 126.357 119.174 125.958 118.779C125.559 118.383 125.022 118.162 124.463 118.162C123.904 118.162 123.367 118.383 122.968 118.779C122.569 119.174 122.34 119.711 122.329 120.276V121.474C122.329 121.876 122.44 122.27 122.65 122.611C122.86 122.953 123.16 123.228 123.517 123.406V124.294C123.517 124.443 123.458 124.585 123.354 124.69C123.251 124.795 123.11 124.854 122.963 124.854H122.716C120.683 124.854 118.976 126.159 118.634 128.817L118.595 128.844C118.285 128.389 118.118 127.849 118.119 127.297V115.524H130.964Z"
          fill="#F7CEDC"
        />
        <path
          d="M130.964 115.134V115.524H118.571V115.24C118.571 111.895 120.437 110.261 122.713 110.261H122.96C123.107 110.261 123.248 110.202 123.352 110.097C123.456 109.992 123.514 109.849 123.514 109.701V108.815C123.157 108.637 122.857 108.362 122.647 108.02C122.437 107.679 122.326 107.285 122.327 106.884V105.684C122.321 105.398 122.372 105.114 122.477 104.848C122.582 104.582 122.738 104.339 122.937 104.135C123.136 103.931 123.373 103.768 123.634 103.658C123.896 103.547 124.177 103.49 124.46 103.49C124.744 103.49 125.024 103.547 125.286 103.658C125.547 103.768 125.784 103.931 125.983 104.135C126.182 104.339 126.338 104.582 126.443 104.848C126.548 105.114 126.599 105.398 126.594 105.684V106.886C126.593 107.288 126.482 107.682 126.272 108.023C126.062 108.364 125.761 108.64 125.404 108.817V109.699C125.404 109.847 125.463 109.989 125.567 110.094C125.671 110.199 125.811 110.258 125.958 110.259C126.593 110.237 127.225 110.348 127.815 110.587C128.405 110.826 128.938 111.185 129.383 111.644C129.827 112.102 130.171 112.649 130.394 113.25C130.617 113.85 130.714 114.491 130.678 115.131L130.964 115.134Z"
          fill="#006B99"
        />
        <path
          d="M130.964 100.809V101.113H118.571V100.916C118.571 97.5708 120.437 95.9365 122.713 95.9365H122.96C123.107 95.9361 123.247 95.8773 123.352 95.7724C123.455 95.6675 123.514 95.5254 123.514 95.377V94.4891C123.157 94.3112 122.857 94.036 122.647 93.6948C122.437 93.3535 122.326 92.96 122.327 92.5583V91.3585C122.321 91.0724 122.372 90.7878 122.477 90.5217C122.582 90.2559 122.738 90.0135 122.937 89.8091C123.136 89.6046 123.373 89.4425 123.634 89.3316C123.896 89.2208 124.177 89.1638 124.46 89.1638C124.744 89.1638 125.024 89.2208 125.286 89.3316C125.547 89.4425 125.784 89.6046 125.983 89.8091C126.182 90.0135 126.338 90.2559 126.443 90.5217C126.548 90.7878 126.599 91.0724 126.594 91.3585V92.5583C126.593 92.96 126.482 93.3538 126.272 93.6951C126.062 94.0364 125.761 94.3112 125.404 94.4891V95.3754C125.404 95.5238 125.462 95.6659 125.567 95.7708C125.67 95.8757 125.811 95.9349 125.958 95.9349C126.593 95.913 127.226 96.0247 127.815 96.2633C128.405 96.5019 128.939 96.8619 129.383 97.3206C129.827 97.7793 130.172 98.3262 130.395 98.9267C130.617 99.5272 130.714 100.168 130.678 100.809H130.964Z"
          fill="#006B99"
        />
        <path
          d="M127.781 75.8286L127.687 76.017L124.187 79.7572C124.132 79.8166 124.066 79.8642 123.992 79.8965C123.919 79.929 123.839 79.9459 123.759 79.9459C123.635 79.9459 123.515 79.9071 123.415 79.8348C123.348 79.786 123.292 79.7237 123.251 79.6516C123.21 79.5793 123.184 79.4995 123.176 79.4165C123.168 79.3339 123.177 79.2503 123.203 79.1714C123.23 79.0925 123.272 79.0202 123.328 78.9591L127.08 74.9529L127.059 74.895C127.18 74.8496 127.317 74.7938 127.461 74.7356C127.425 74.7938 126.893 75.606 127.781 75.8286Z"
          fill="#006B99"
        />
        <path
          d="M114.375 50.0774L116.356 51.0724C115.973 52.284 114.378 51.8867 114.378 51.8867L114.375 50.0774Z"
          fill="#FFCEB6"
        />
        <path
          d="M115.492 88.9603V97.4662H111.934V97.3779L109.508 94.4894C109.992 93.3538 110.25 92.1334 110.268 90.8974C110.268 89.4622 109.332 87.6711 108.525 86.3902L111.934 84.0039L115.492 88.9603Z"
          fill="#FFCEB6"
        />
        <path
          d="M107.816 47.6394V77.4898L107.779 77.5659C107.279 77.3386 106.754 77.1739 106.216 77.0756L106.239 76.9563V47.6394H107.816Z"
          fill="#CCEFF6"
        />
        <path
          d="M102.321 70.4728C102.749 71.3347 102.274 72.5877 101.37 72.7016C101.049 72.7467 100.723 72.6938 100.432 72.5495C100.804 71.9925 101.089 71.3801 101.275 70.7348C101.386 70.4665 101.567 70.1747 101.743 69.8037C101.993 69.9684 102.193 70.2001 102.321 70.4728Z"
          fill="#006B99"
        />
        <path
          d="M99.3172 76.0357L102.221 76.9593C102.221 76.9593 100.624 78.742 96.3166 78.9752C93.6156 79.0657 90.9462 78.3654 88.6303 76.9593L92.2881 75.4336L89.9156 72.9509C89.9316 72.9509 89.6031 70.3053 89.6191 70.3031C90.0706 70.2446 93.2528 73.0968 93.5125 72.7198L94.2175 72.8839C94.9084 73.3626 95.6641 73.738 96.4612 73.9985L96.4875 74.0069C96.7187 74.0943 98.4581 74.7389 99.2487 74.9828H99.2631L99.2706 75.1287L99.3172 76.0357Z"
          fill="#FFCEB6"
        />
        <path
          d="M100.363 70.1358C100.28 70.1959 100.191 70.2485 100.098 70.2924C100.098 70.2924 99.1947 70.0932 98.8625 70.0641C98.5975 70.0406 97.0943 70.1152 96.5162 70.1493C96.3747 70.1546 96.2903 70.1599 96.2903 70.1599C96.6662 70.4849 97.0631 70.7845 97.4778 71.0569C97.7003 71.2216 97.9572 71.3321 98.2287 71.38C98.5006 71.4279 98.7794 71.4119 99.044 71.333C99.5381 70.9993 99.9822 70.5964 100.363 70.1358ZM88.9647 66.3954C89.3765 65.9395 89.9493 66.191 90.32 66.4458C90.7006 66.7238 91.1622 66.8656 91.6315 66.8487C94.1065 66.6844 94.6294 62.9518 94.7844 61.6252C94.7844 61.6252 98.1772 61.9963 99.2728 62.5429C99.3775 62.5961 99.4831 62.6547 99.5853 62.7132C100.661 63.351 101.456 64.3782 101.809 65.5861L101.782 65.6618C101.714 65.861 101.654 65.9934 101.654 65.9934C101.977 66.6944 102.097 67.4733 102 68.2404C101.901 68.8077 101.725 69.3584 101.477 69.8772C101.243 70.3791 100.997 70.7711 100.85 71.1324C100.598 71.9999 100.215 72.823 99.714 73.5725C99.5672 73.7494 99.3903 73.8988 99.1915 74.0134C99.0031 74.1211 98.7962 74.1921 98.5815 74.2225C97.9931 74.2917 97.3965 74.2494 96.8234 74.0979C96.7134 74.0713 96.5975 74.0422 96.49 74.008L96.4634 73.9996C95.6665 73.7388 94.9106 73.3637 94.2197 72.8853L92.99 72.7209C93.2293 72.426 93.3743 72.0644 93.4059 71.6843C93.4372 71.3046 93.3537 70.9235 93.1662 70.5926C92.7143 69.8766 92.3884 69.5898 91.2422 70.1023C90.9653 70.2473 90.7368 70.4714 90.5856 70.747L90.5065 71.1073C89.7372 70.6596 88.0219 68.3196 88.7569 66.7279C88.8075 66.6061 88.8775 66.494 88.9647 66.3954Z"
          fill="#FFCEB6"
        />
        <path
          d="M94.7791 61.6119C94.7806 61.6163 94.7806 61.621 94.7791 61.6254C94.6166 63.0502 94.0225 67.2418 91.0556 66.8254C90.8466 66.7944 90.6497 66.707 90.4856 66.5727C90.1438 66.2969 89.445 65.8567 88.9616 66.3958C88.8747 66.4945 88.8035 66.6062 88.7506 66.7271C88.015 68.3191 89.3975 69.6244 90.1672 70.0721L90.7875 70.5023C90.6503 70.7383 90.5744 71.0057 90.5672 71.2793C90.5597 71.553 90.621 71.8241 90.7453 72.0677C91.0685 72.9881 91.8094 72.8839 92.375 72.8977L92.2853 75.4336L88.6272 76.9593C87.0294 77.2301 85.4788 77.7339 84.0244 78.4546C82.6606 74.6293 87.1485 68.3129 88.3969 64.5962C88.5278 64.2086 88.3675 61.3702 90.4253 59.028C91.4681 58.1793 92.6897 57.5828 93.996 57.2848C94.1466 57.2453 94.2913 57.21 94.4297 57.1793C95.7963 56.92 97.2091 57.1091 98.4616 57.7184C99.7141 58.328 100.741 59.3261 101.391 60.5665C103.152 64.1883 101.806 65.5837 101.806 65.5837C101.453 64.3761 100.658 63.3489 99.5831 62.7112C98.6491 61.9328 97.5444 61.3915 96.3613 61.1323C94.7453 60.8693 94.7685 61.5192 94.7791 61.6119Z"
          fill="#006B99"
        />
        <path
          d="M99.5834 62.7132C99.4809 62.6547 99.3756 62.5961 99.2703 62.5429C98.1747 61.9962 94.7825 61.6252 94.7825 61.6252C94.7837 61.6209 94.7837 61.6162 94.7825 61.6118C94.7719 61.5188 94.7484 60.8688 96.3638 61.1343C97.5463 61.3942 98.65 61.9355 99.5834 62.7132Z"
          fill="#006B99"
        />
        <path
          d="M99.2128 74.0539L99.2625 74.9828H99.2487C98.4581 74.7386 96.7187 74.0939 96.4875 74.0066C96.5975 74.0407 96.7134 74.0698 96.8212 74.0964C97.3944 74.248 97.9906 74.2902 98.5794 74.2211C98.7937 74.1907 99.0003 74.1196 99.1884 74.0119L99.2128 74.0539Z"
          fill="#006B99"
        />
        <path
          d="M92.2359 72.7673C91.8934 72.8086 91.5475 72.7259 91.2597 72.534C90.9722 72.3421 90.7612 72.0534 90.6644 71.7191C90.5944 71.5196 90.5691 71.3071 90.5912 71.0963C90.6131 70.886 90.6812 70.6831 90.7909 70.5027C90.8962 70.3246 91.0544 70.1846 91.2428 70.1023C91.4053 70.0056 91.5866 69.9445 91.7744 69.9235C91.9622 69.9029 92.1522 69.9223 92.3319 69.9808C92.5116 70.0394 92.6769 70.1358 92.8169 70.2639C92.9572 70.3916 93.0687 70.5478 93.1447 70.7225C93.2581 70.9724 93.3053 71.2476 93.2825 71.5212C93.2597 71.7952 93.1669 72.0585 93.0137 72.2854C92.9312 72.4141 92.8222 72.5234 92.6947 72.606C92.5669 72.6887 92.4231 72.7429 92.2728 72.7651C92.2606 72.7645 92.2494 72.7673 92.2359 72.7673Z"
          fill="#CCEFF6"
        />
        <path
          d="M88.6303 89.9234L88.3991 97.4663H80.7684V89.6082L88.6303 89.9234Z"
          fill="#FFCEB6"
        />
        <path
          d="M84.7888 44.8433C84.9735 44.8429 85.1544 44.8981 85.3085 45.0017C85.4622 45.1053 85.5822 45.2525 85.6531 45.425C85.7241 45.5975 85.7428 45.7872 85.7066 45.9704C85.6706 46.1535 85.5816 46.3216 85.451 46.4538C85.32 46.5859 85.1535 46.6757 84.9722 46.7121C84.7907 46.7484 84.6025 46.7296 84.4319 46.6579C84.261 46.5865 84.115 46.4653 84.0125 46.3097C83.91 46.1545 83.8553 45.9719 83.8557 45.7853C83.856 45.5355 83.9544 45.296 84.1291 45.1194C84.3041 44.9428 84.5413 44.8436 84.7888 44.8433Z"
          fill="#FFCEB6"
        />
        <path
          d="M81.1103 44.8433C81.2953 44.8429 81.4762 44.8981 81.63 45.0017C81.7841 45.1053 81.9041 45.2525 81.9747 45.425C82.0456 45.5975 82.0644 45.7872 82.0284 45.9704C81.9925 46.1535 81.9034 46.3216 81.7725 46.4538C81.6419 46.5859 81.475 46.6757 81.2937 46.7121C81.1122 46.7484 80.9244 46.7296 80.7534 46.6579C80.5828 46.5865 80.4369 46.4653 80.3341 46.3097C80.2316 46.1545 80.1772 45.9719 80.1775 45.7853C80.1775 45.5355 80.2759 45.296 80.4509 45.1194C80.6256 44.9428 80.8628 44.8436 81.1103 44.8433Z"
          fill="#CCEFF6"
        />
        <path
          d="M178.712 132.211C178.184 132.521 177.585 132.684 176.975 132.683H118.942C118.488 132.683 118.04 132.593 117.621 132.418C117.202 132.243 116.822 131.987 116.501 131.663C116.181 131.34 115.927 130.956 115.753 130.533C115.58 130.11 115.491 129.657 115.492 129.2V87.4888C115.492 86.5646 115.855 85.6786 116.502 85.0252C117.149 84.3718 118.027 84.0045 118.942 84.0039H176.975C177.428 84.0039 177.877 84.0938 178.296 84.2691C178.715 84.4441 179.096 84.7008 179.417 85.0246C179.738 85.3483 179.992 85.7328 180.165 86.1557C180.339 86.579 180.428 87.0324 180.428 87.4901V129.201C180.428 129.811 180.269 130.409 179.968 130.937C179.667 131.466 179.234 131.905 178.712 132.211Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.964 130.03H120.828C120.109 130.03 119.419 129.741 118.911 129.228C118.403 128.715 118.117 128.019 118.117 127.293V89.3905C118.117 88.6647 118.403 87.9684 118.911 87.4553C119.419 86.9422 120.109 86.6538 120.828 86.6538H175.088C175.808 86.6538 176.497 86.9422 177.005 87.4553C177.514 87.9684 177.799 88.6647 177.799 89.3905V127.294C177.799 128.02 177.514 128.716 177.005 129.229C176.497 129.743 175.808 130.031 175.088 130.031H130.964V130.03Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M144.559 85.5518H149.034"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.963 86.6558V100.809V101.111V115.134V115.524V129.725V130.03"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M165.124 86.6558V100.809V101.111V115.134V115.524V129.725V130.03"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M118.119 101.111H118.571H130.963"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M118.119 115.524H118.571H130.963"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.68 100.809C130.716 100.169 130.619 99.5281 130.396 98.9279C130.172 98.3281 129.828 97.7814 129.384 97.3231C128.94 96.865 128.406 96.5053 127.817 96.267C127.227 96.0285 126.595 95.917 125.96 95.9389C125.813 95.9386 125.672 95.8797 125.569 95.7749C125.465 95.67 125.406 95.5278 125.406 95.3794V94.4893C125.763 94.3115 126.064 94.0363 126.274 93.6951C126.484 93.3541 126.596 92.9602 126.596 92.5582V91.3588C126.585 90.7943 126.356 90.2568 125.957 89.8616C125.558 89.4662 125.021 89.2449 124.462 89.2449C123.903 89.2449 123.367 89.4662 122.967 89.8616C122.569 90.2568 122.339 90.7943 122.329 91.3588V92.5582C122.328 92.9599 122.44 93.3538 122.649 93.6951C122.859 94.036 123.16 94.3112 123.516 94.4893V95.3757C123.516 95.5238 123.457 95.6662 123.354 95.7711C123.25 95.876 123.109 95.9349 122.962 95.9352H122.715C120.437 95.9352 118.574 97.5717 118.574 100.914"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.68 115.134C130.716 114.494 130.619 113.853 130.396 113.252C130.173 112.652 129.829 112.105 129.385 111.646C128.941 111.188 128.407 110.828 127.817 110.589C127.228 110.351 126.595 110.239 125.96 110.261C125.813 110.26 125.673 110.201 125.569 110.096C125.465 109.991 125.406 109.849 125.406 109.701V108.815C125.763 108.637 126.063 108.363 126.274 108.022C126.484 107.681 126.596 107.287 126.597 106.886V105.685C126.586 105.12 126.357 104.583 125.958 104.188C125.558 103.792 125.022 103.571 124.463 103.571C123.904 103.571 123.367 103.792 122.968 104.188C122.569 104.583 122.34 105.12 122.329 105.685V106.886C122.329 107.287 122.44 107.681 122.65 108.023C122.86 108.364 123.16 108.639 123.517 108.817V109.698C123.517 109.847 123.458 109.989 123.354 110.094C123.251 110.199 123.11 110.259 122.963 110.259H122.716C120.437 110.259 118.574 111.895 118.574 115.238"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.68 129.725C130.716 129.085 130.619 128.444 130.397 127.843C130.174 127.242 129.829 126.695 129.385 126.237C128.941 125.778 128.407 125.418 127.817 125.179C127.227 124.941 126.595 124.829 125.96 124.851C125.813 124.851 125.672 124.792 125.568 124.687C125.465 124.582 125.406 124.44 125.406 124.292V123.405C125.763 123.228 126.064 122.953 126.274 122.611C126.484 122.27 126.596 121.876 126.596 121.474V120.276C126.585 119.711 126.356 119.174 125.957 118.778C125.558 118.383 125.021 118.162 124.462 118.162C123.903 118.162 123.366 118.383 122.967 118.778C122.568 119.174 122.339 119.711 122.328 120.276V121.474C122.328 121.876 122.439 122.27 122.649 122.611C122.859 122.952 123.159 123.228 123.516 123.405V124.294C123.516 124.442 123.457 124.585 123.353 124.69C123.25 124.795 123.109 124.853 122.962 124.853H122.715C120.682 124.853 118.975 126.159 118.633 128.817"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M177.8 101.111H177.285H165.155"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M177.8 115.524H177.285H165.155"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M165.176 100.809C165.14 100.169 165.237 99.5286 165.46 98.9287C165.683 98.3289 166.028 97.7822 166.471 97.3242C166.915 96.8658 167.448 96.5061 168.037 96.2675C168.627 96.0293 169.258 95.9172 169.893 95.9388C170.041 95.9385 170.182 95.8796 170.287 95.7747C170.391 95.6699 170.45 95.5277 170.45 95.3793V94.4892C170.093 94.3117 169.792 94.0365 169.582 93.6952C169.372 93.354 169.26 92.9604 169.26 92.5584V91.3587C169.26 90.7873 169.484 90.2394 169.885 89.8355C170.285 89.4313 170.827 89.2043 171.393 89.2043C171.959 89.2043 172.502 89.4313 172.903 89.8355C173.303 90.2394 173.528 90.7873 173.528 91.3587V92.5584C173.527 92.9604 173.416 93.354 173.205 93.6952C172.995 94.0365 172.694 94.3117 172.337 94.4892V95.3755C172.338 95.5243 172.397 95.6667 172.501 95.7716C172.606 95.8765 172.747 95.9353 172.894 95.935H173.138C175.419 95.935 177.285 97.5718 177.285 100.914"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M165.176 115.134C165.14 114.494 165.237 113.853 165.459 113.253C165.682 112.652 166.026 112.105 166.47 111.647C166.914 111.189 167.448 110.828 168.037 110.59C168.626 110.351 169.258 110.239 169.893 110.261C170.041 110.261 170.183 110.201 170.288 110.096C170.392 109.991 170.45 109.849 170.45 109.701V108.815C170.093 108.637 169.792 108.362 169.582 108.021C169.372 107.679 169.26 107.285 169.26 106.883V105.684C169.26 105.113 169.485 104.565 169.885 104.161C170.285 103.757 170.828 103.53 171.394 103.53C171.96 103.53 172.503 103.757 172.903 104.161C173.303 104.565 173.528 105.113 173.528 105.684V106.886C173.528 107.288 173.416 107.682 173.206 108.023C172.995 108.364 172.694 108.64 172.337 108.817V109.698C172.338 109.847 172.397 109.99 172.501 110.094C172.606 110.2 172.747 110.259 172.894 110.259H173.138C175.419 110.259 177.285 111.895 177.285 115.238"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M165.176 129.725C165.14 129.085 165.237 128.444 165.459 127.844C165.682 127.243 166.026 126.696 166.47 126.238C166.914 125.779 167.448 125.419 168.037 125.18C168.626 124.942 169.258 124.829 169.893 124.851C169.966 124.852 170.038 124.837 170.106 124.809C170.173 124.781 170.235 124.74 170.287 124.688C170.338 124.636 170.379 124.575 170.408 124.506C170.436 124.438 170.45 124.365 170.45 124.292V123.406C170.093 123.228 169.792 122.953 169.582 122.612C169.372 122.27 169.26 121.876 169.26 121.474V120.276C169.26 119.704 169.485 119.156 169.885 118.752C170.285 118.348 170.828 118.121 171.394 118.121C171.96 118.121 172.503 118.348 172.903 118.752C173.303 119.156 173.528 119.704 173.528 120.276V121.474C173.528 121.876 173.416 122.27 173.206 122.612C172.995 122.953 172.694 123.228 172.337 123.406V124.294C172.338 124.443 172.397 124.585 172.501 124.69C172.606 124.795 172.747 124.854 172.894 124.854H173.138C175.172 124.854 176.88 126.159 177.222 128.817"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M165.124 84.0025V74.433V70.3933H221.475V74.433V108.343H180.428"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M165.124 74.4329H221.475"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M168.763 72.5793C168.764 72.7659 168.709 72.9484 168.607 73.1037C168.504 73.259 168.359 73.3801 168.188 73.4518C168.017 73.5235 167.829 73.5423 167.648 73.5063C167.467 73.47 167.3 73.3805 167.169 73.2486C167.038 73.1168 166.949 72.9487 166.913 72.7659C166.877 72.5827 166.895 72.393 166.965 72.2205C167.036 72.048 167.156 71.9005 167.309 71.7969C167.463 71.6929 167.643 71.6375 167.828 71.6372C167.951 71.6372 168.072 71.6613 168.186 71.7086C168.299 71.7559 168.402 71.8251 168.489 71.9127C168.576 72.0001 168.645 72.104 168.692 72.2183C168.739 72.3326 168.763 72.4553 168.763 72.5793Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M172.44 72.5793C172.44 72.7659 172.385 72.9481 172.283 73.1037C172.181 73.259 172.035 73.3801 171.864 73.4518C171.693 73.5232 171.506 73.5423 171.324 73.5063C171.143 73.47 170.977 73.3805 170.846 73.249C170.715 73.1172 170.625 72.949 170.589 72.7662C170.553 72.5834 170.571 72.3936 170.641 72.2211C170.712 72.0486 170.831 71.9011 170.985 71.7972C171.138 71.6933 171.319 71.6375 171.504 71.6372C171.627 71.6369 171.748 71.661 171.862 71.7083C171.975 71.7556 172.078 71.8247 172.165 71.9124C172.252 71.9998 172.321 72.1037 172.368 72.2183C172.415 72.3326 172.44 72.4553 172.44 72.5793Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M176.118 72.5793C176.118 72.7659 176.064 72.9484 175.961 73.1037C175.859 73.259 175.713 73.3801 175.543 73.4518C175.372 73.5235 175.184 73.5423 175.003 73.5063C174.821 73.47 174.654 73.3805 174.524 73.2487C174.393 73.1168 174.303 72.9487 174.267 72.7659C174.231 72.5827 174.249 72.393 174.32 72.2205C174.391 72.048 174.51 71.9005 174.664 71.7969C174.817 71.6929 174.998 71.6375 175.183 71.6372C175.306 71.6369 175.427 71.661 175.541 71.7083C175.654 71.7556 175.757 71.8247 175.844 71.9124C175.931 71.9998 176 72.1037 176.047 72.2183C176.094 72.3326 176.118 72.4553 176.118 72.5793Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M115.491 97.4663H111.933H107.816H88.3991H80.7685H78.4084V47.6392V43.5989H155.782V47.6392V84.0024"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.4084 47.6394H106.239H107.816H155.782"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M82.0456 45.7853C82.046 45.9719 81.9913 46.1545 81.8891 46.3097C81.7866 46.465 81.6406 46.5862 81.47 46.6579C81.2994 46.7296 81.1116 46.7484 80.93 46.7124C80.7488 46.6761 80.5822 46.5865 80.4513 46.4547C80.3203 46.3229 80.2313 46.1548 80.195 45.9719C80.1588 45.7888 80.1769 45.599 80.2475 45.4265C80.3181 45.254 80.4378 45.1066 80.5913 45.0029C80.745 44.899 80.9256 44.8436 81.1103 44.8433C81.3581 44.8433 81.5956 44.9422 81.7713 45.1188C81.9466 45.2954 82.0453 45.5352 82.0456 45.7853Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M85.7247 45.7853C85.725 45.9719 85.6703 46.1541 85.5678 46.3094C85.4656 46.465 85.3197 46.5862 85.1491 46.6576C84.9784 46.7293 84.7906 46.7484 84.6094 46.7124C84.4281 46.6761 84.2613 46.5865 84.1303 46.455C83.9997 46.3232 83.9103 46.1551 83.8741 45.9722C83.8375 45.7894 83.8556 45.5997 83.9263 45.4272C83.9966 45.2547 84.1163 45.1072 84.2697 45.0032C84.4231 44.8993 84.6038 44.8436 84.7888 44.8433C84.9113 44.8433 85.0328 44.8674 85.1463 44.9146C85.2597 44.9619 85.3628 45.0311 85.4497 45.1185C85.5369 45.2061 85.6056 45.3101 85.6528 45.4243C85.7 45.5386 85.7244 45.6614 85.7247 45.7853Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M89.4028 45.7853C89.4031 45.9719 89.3488 46.1545 89.2463 46.3097C89.1438 46.465 88.9981 46.5862 88.8272 46.6579C88.6566 46.7296 88.4687 46.7484 88.2875 46.7124C88.1059 46.6761 87.9394 46.5865 87.8084 46.4547C87.6778 46.3229 87.5884 46.1548 87.5522 45.9719C87.5159 45.7888 87.5344 45.599 87.6047 45.4265C87.6753 45.254 87.795 45.1066 87.9487 45.0029C88.1022 44.899 88.2828 44.8436 88.4678 44.8433C88.7153 44.8433 88.9531 44.9422 89.1284 45.1188C89.3037 45.2954 89.4025 45.5352 89.4028 45.7853Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M141.015 149.219L117.883 132.683V133.595C117.882 134.216 118.03 134.827 118.312 135.379C118.595 135.93 119.004 136.404 119.507 136.763L146.99 156.41C148.136 157.227 149.503 157.666 150.906 157.667H207.465C207.829 157.668 208.19 157.595 208.527 157.454C208.864 157.314 209.17 157.107 209.428 156.847C209.685 156.587 209.89 156.278 210.029 155.938C210.168 155.598 210.24 155.234 210.24 154.866V154.749"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M178.712 132.211L210.236 154.746H148.748"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M173.997 81.3098H212.599"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M180.83 90.064H212.599"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M180.83 98.8184H212.599"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M100.889 121.554H113.67"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M182.349 121.554H200.385"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M141.015 149.219L148.748 154.747V157.243"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M163.2 152.625L157.217 148.348H181.216"
          stroke="#F7CEDC"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M181.277 148.348L187.26 152.625H163.261"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M193.291 146.268H176.751H143.364L132.038 138.171L127.713 135.078H146.107H177.64L188.432 142.795L193.291 146.268Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M132.038 138.171H150.432H175.188"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M145.177 142.947H172.242H188.327"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M146.107 135.078L150.432 138.171L154.941 141.395"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M167.917 139.854L172.242 142.947L176.751 146.17"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M154.208 112.207C154.926 112.207 155.636 112.35 156.298 112.627C156.961 112.904 157.563 113.31 158.07 113.823C158.577 114.335 158.979 114.943 159.254 115.612C159.528 116.281 159.669 116.998 159.669 117.722C159.67 117.74 159.67 117.757 159.669 117.775C159.669 119.237 159.094 120.639 158.07 121.673C157.046 122.706 155.657 123.287 154.21 123.287C152.762 123.287 151.373 122.706 150.35 121.673C149.326 120.639 148.751 119.237 148.751 117.775C148.749 117.757 148.749 117.74 148.751 117.722C148.75 116.26 149.325 114.858 150.348 113.824C151.372 112.789 152.76 112.208 154.208 112.207Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M154.208 108.712V112.208V117.776V123.236V126.311"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M162.924 117.776H159.666H154.208H148.751H145.492"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M134.33 66.8061C134.363 65.3668 134.953 63.9977 135.973 62.9918C136.993 61.9858 138.363 61.4226 139.789 61.4226C141.215 61.4226 142.584 61.9858 143.604 62.9918C144.624 63.9977 145.214 65.3668 145.248 66.8061C145.249 66.8249 145.249 66.8437 145.248 66.8624C145.235 68.1611 144.768 69.4135 143.929 70.3987C143.091 71.3837 141.935 72.0387 140.666 72.2478C139.396 72.4566 138.094 72.2065 136.989 71.5412C135.884 70.8759 135.048 69.838 134.626 68.6107"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M139.79 57.7969V61.2937V66.8622V72.319V75.3963"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M134.6 66.8623H134.33H131.074"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M148.506 66.8623H145.248H139.79H136.423"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M134.182 96.0173V99.5802L142.825 98.5561L153.115 97.336V101.878V103.732L151.297 102.816L142.825 98.5561L136.161 95.203L134.182 94.208V96.0173Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M134.182 96.015C134.182 96.015 135.774 96.4133 136.161 95.2007"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M151.294 102.816C151.482 102.505 151.751 102.253 152.072 102.087C152.393 101.921 152.753 101.849 153.113 101.877"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M114.375 51.8867V55.4518L123.02 54.4255L133.307 53.2048V57.747V59.6011L131.489 58.6856L123.02 54.4255L116.353 51.0724L114.375 50.0774V51.8867Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M114.375 51.8866C114.375 51.8866 115.97 52.2842 116.353 51.0723"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M131.491 58.6895C131.678 58.3783 131.947 58.126 132.269 57.96C132.59 57.7944 132.95 57.7218 133.31 57.7509"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M145.481 115.179H139.075V112.526V108.712H142.854H145.481V115.179Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M142.854 112.526H139.075H136.448V106.059H142.854V108.712V112.526Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M136.448 106.059L139.075 108.712"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M142.854 106.059L145.482 108.712"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M142.854 112.526L145.482 115.179"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M136.448 112.526L139.075 115.179"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M121.837 73.4762H115.43V70.8232V67.0085H119.21H121.837V73.4762Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M119.21 70.8227H115.431H112.803V64.355H119.21V67.0081V70.8227Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M112.803 64.355L115.431 67.0081"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M119.21 64.355L121.837 67.0081"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M119.21 70.8228L121.837 73.4758"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M112.803 70.8228L115.431 73.4758"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M136.185 123.453C136.185 123.453 135.11 123.894 135.056 124.663C135.001 125.433 135.983 125.435 136.419 124.995C136.435 124.47 136.381 123.945 136.257 123.435C136.212 123.259 136.147 123.089 136.064 122.928C135.657 122.159 134.974 122.267 134.729 122.79"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M156.976 91.606C156.976 91.606 155.9 92.0462 155.846 92.8183C155.792 93.5906 156.774 93.5906 157.21 93.1498C157.226 92.6241 157.171 92.0985 157.047 91.5875C157.003 91.4125 156.939 91.2434 156.855 91.0838C156.448 90.3114 155.765 90.4232 155.52 90.9454"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M137.761 123.236H139.075"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M137.761 124.297H139.075"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M140.301 122.904C140.367 122.068 142.343 122.053 141.962 123.501C141.702 124.486 140.34 125.292 140.34 125.292H142.569"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M149.389 91.0135C149.457 90.181 151.433 90.1623 151.046 91.6081C150.786 92.5962 149.427 93.4014 149.427 93.4014H151.653"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M144.835 89.9425C144.88 89.3824 146.207 89.3717 145.95 90.3432C145.776 91.0007 144.864 91.5442 144.864 91.5442H146.356"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M144.021 124.806C144.924 125.862 146.304 125.196 145.836 124.122C145.368 123.048 144.105 123.817 144.021 124.806Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M144.851 121.891C144.31 122.472 143.119 123.748 144.023 124.806"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M153.422 90.7964V91.6433V92.4892"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M152.487 91.6428H153.422H154.29"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M148.647 89.5337C147.873 89.7723 147.229 91.2607 147.471 92.3082C147.535 92.755 147.713 93.1771 147.987 93.5337C148.262 93.8903 148.623 94.1689 149.035 94.3427"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M157.793 89.5337C158.568 89.7723 159.212 91.2607 158.97 92.3082C158.905 92.7544 158.727 93.1758 158.453 93.5321C158.179 93.8884 157.818 94.167 157.407 94.3411"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M106.239 47.6394V76.9591"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M107.816 47.6394V77.4898"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M88.6303 88.5808V89.9233L80.7684 89.608L79.9041 89.5739C79.9041 89.5739 79.9622 83.3864 81.5803 80.5884C82.1853 79.6638 83.0309 78.9253 84.0244 78.4544C85.4797 77.7324 87.0312 77.2274 88.6303 76.956C90.9466 78.3623 93.6159 79.0624 96.3169 78.9722C100.624 78.7387 102.221 76.956 102.221 76.956C103.552 76.8054 104.896 76.8454 106.216 77.0752C106.754 77.1739 107.279 77.3386 107.779 77.5659C108.159 77.738 108.51 77.971 108.817 78.2559C110.315 79.8254 111.629 81.5636 112.732 83.4368L111.932 83.9991L108.525 86.3901"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M80.7684 89.6082V97.4663"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M88.6306 89.9238L88.3994 97.4663"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M107.366 84.7346C107.366 84.7346 107.908 85.414 108.525 86.3902C109.332 87.671 110.265 89.4622 110.267 90.8974C110.25 92.1334 109.992 93.3538 109.508 94.4894C109.083 95.5282 108.513 96.501 107.816 97.3779"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M101.399 89.6082C101.399 89.6082 101.598 93.3696 100.208 95.0593"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M100.897 66.6396C100.658 66.5347 100.404 66.4699 100.144 66.448C99.9 66.3964 99.6469 66.412 99.4109 66.4937"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M95.371 66.3674C95.6647 66.2941 95.9632 66.2409 96.2641 66.208C96.5091 66.1598 96.7625 66.1792 96.9975 66.2641"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M99.0681 65.6252C98.9669 65.841 98.9156 66.077 98.9178 66.3156C98.92 66.5542 98.9759 66.789 99.0809 67.0028C99.2363 67.5282 99.7331 68.0877 99.646 68.5839C99.5585 69.0804 98.6525 69.2786 98.1219 69.1327"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M96.4616 73.9984C95.6644 73.7379 94.9088 73.3625 94.2178 72.8838"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M101.475 69.8757C101.242 70.3773 100.995 70.7696 100.847 71.1306C100.595 71.9981 100.213 72.8212 99.7122 73.5708C99.5638 73.7483 99.3853 73.8976 99.185 74.0119C98.9969 74.1196 98.7903 74.1903 98.5759 74.2207C97.9872 74.2902 97.3909 74.248 96.8178 74.0961C96.7072 74.0695 96.5919 74.0407 96.4841 74.0066"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M101.78 65.6604C101.711 65.8598 101.651 65.992 101.651 65.992C101.975 66.693 102.095 67.4719 101.998 68.239C101.897 68.8063 101.72 69.357 101.471 69.8758"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M94.7087 65.4164C95.3709 64.9991 96.1487 64.8081 96.9269 64.8723C97.7778 65.0182 97.8253 65.3153 97.8306 65.3284"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M101.501 64.9571C101.252 64.9327 101 64.948 100.755 65.0019C100.39 65.072 100.03 65.1715 99.6806 65.2993"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M100.367 70.1337C100.283 70.1938 100.194 70.2464 100.102 70.2902C99.7375 70.4439 99.3478 70.5263 98.9532 70.5319C98.1307 70.4962 97.3144 70.3688 96.5194 70.1518C96.3485 70.1092 96.2303 70.0757 96.1913 70.0667"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M96.1759 70.0642C96.1759 70.0642 96.2203 70.1015 96.2918 70.1647C96.6678 70.4894 97.0647 70.789 97.4793 71.0617C97.7018 71.2264 97.9587 71.3369 98.2306 71.3848C98.5022 71.4327 98.7809 71.4164 99.0456 71.3375C99.5406 71.0028 99.9856 70.598 100.367 70.1359"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M99.2128 74.0542L99.2628 74.9831L99.2706 75.129L99.3185 76.0357"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M102.221 76.9592L99.3175 76.0356"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M92.3778 72.8975L92.2881 75.4334L88.6303 76.9591"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M90.6906 66.7537C90.6906 66.7537 89.6266 65.6604 88.9647 66.3955C88.8778 66.4945 88.8066 66.6062 88.7538 66.7271C88.0181 68.3188 89.5897 70.0668 90.7869 70.5023"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M88.9647 66.3955V66.4015"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M93.0137 72.2847C93.1684 72.0583 93.2619 71.795 93.2847 71.5207C93.3078 71.2468 93.2594 70.9713 93.1447 70.7218C93.0684 70.5477 92.9566 70.3918 92.8162 70.2643C92.6759 70.1366 92.5106 70.0405 92.3312 69.9819C92.1516 69.9234 91.9619 69.904 91.7744 69.9243C91.5869 69.945 91.4056 70.0054 91.2428 70.1015C91.0553 70.1854 90.8975 70.3254 90.7909 70.502C90.6812 70.6823 90.6131 70.8852 90.5912 71.0959C90.5691 71.3063 90.5944 71.5189 90.6644 71.7183C90.7625 72.0517 90.9737 72.3398 91.2612 72.5314C91.5484 72.7233 91.8937 72.8066 92.2359 72.7668C92.2466 72.7668 92.2569 72.7668 92.2675 72.7668C92.4187 72.7446 92.5634 72.6901 92.6922 72.6071C92.8209 72.5239 92.9306 72.414 93.0137 72.2847Z"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M100.429 72.5501C100.719 72.6956 101.047 72.7485 101.367 72.7022C102.271 72.5879 102.747 71.3337 102.319 70.4734C102.191 70.1997 101.99 69.968 101.738 69.8049"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M96.2885 70.1624C96.2885 70.1624 96.375 70.1571 96.5144 70.1518C97.0928 70.1173 98.5956 70.0428 98.8606 70.0666C99.1897 70.0932 100.096 70.2945 100.096 70.2945"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M96.4615 73.9983L96.4878 74.0067C96.719 74.0941 98.4584 74.7387 99.249 74.9826"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M94.7791 61.6118C94.7684 61.5188 94.7453 60.8688 96.3603 61.1343C97.5438 61.3939 98.6484 61.9352 99.5822 62.7132L99.59 62.7207"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M91.6028 59.3144C91.6028 59.3144 94.409 59.1526 94.7797 61.6115C94.7809 61.6162 94.7809 61.6209 94.7797 61.6253"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M90.7544 66.7377C94.2182 68.0558 94.6091 63.1056 94.78 61.6254C94.78 61.6254 98.1682 61.9964 99.2675 62.543C99.3732 62.5963 99.4785 62.6548 99.581 62.7134C100.656 63.3511 101.451 64.3783 101.804 65.5862C101.804 65.5862 103.149 64.1911 101.389 60.5687C100.738 59.3283 99.7119 58.3302 98.4594 57.7206C97.2069 57.1113 95.7941 56.9222 94.4275 57.1815C94.2878 57.2122 94.1435 57.2475 93.9938 57.287C92.6872 57.585 91.466 58.1815 90.4232 59.0302C88.3653 61.3724 88.5257 64.2108 88.3947 64.5984C87.1463 68.3151 82.6585 74.6331 84.0219 78.4568"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M127.461 74.7331C127.933 74.5518 128.381 74.3101 128.793 74.0139C128.912 73.9216 129.012 73.8073 129.09 73.6774C129.136 73.6057 129.165 73.5246 129.175 73.4397C129.185 73.3549 129.175 73.2688 129.146 73.1886C129.117 73.1082 129.07 73.0359 129.009 72.977C128.948 72.9181 128.874 72.8743 128.793 72.8496C128.677 72.817 128.556 72.8045 128.435 72.8123C127.324 72.9936 126.25 73.3612 125.258 73.9C125.01 74.0236 124.801 74.2159 124.656 74.4541L122.404 78.7872L119.977 83.9735"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M126.554 75.0784C126.554 75.0784 126.761 75.0092 127.056 74.895C127.177 74.8496 127.313 74.7938 127.458 74.7356"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M111.933 84.0024L115.491 88.9604"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M109.509 94.489L111.934 97.3778"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M125.789 83.9735L126.919 81.6573C127.547 81.6395 128.163 81.4798 128.722 81.1905C129.28 80.9012 129.768 80.4892 130.148 79.9848C131.735 78.1702 132.111 76.9044 131.444 76.4407C130.777 75.977 129.394 76.6104 128.997 77.369C128.6 78.1276 128.905 79.1623 130.832 77.7087"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M131.444 76.4394C131.444 76.4394 132.319 75.6379 132.035 74.843C131.752 74.0478 130.246 74.4316 129.303 75.0027C128.892 75.2541 128.532 75.5828 128.244 75.9711C127.823 76.5678 127.792 77.2018 128.997 77.3659"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M132.035 74.8442C132.035 74.8442 132.162 74.0386 131.089 73.425C130.372 73.0139 129.176 73.6905 129.176 73.6905"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M127.461 74.7332C127.424 74.7917 126.897 75.6038 127.784 75.8264C127.891 75.854 128 75.8706 128.11 75.8765"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M131.405 72.0484L134.626 68.6101L136.339 66.7855L137.996 65.0187C138.102 64.9041 138.158 64.7517 138.152 64.5951C138.146 64.4383 138.079 64.2905 137.965 64.1837C137.852 64.0773 137.701 64.0206 137.545 64.0263C137.39 64.0319 137.244 64.0998 137.138 64.2147L134.653 66.9073L130.281 71.6423"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M127.077 74.9529L123.325 78.9591C123.269 79.0202 123.227 79.0925 123.201 79.1714C123.175 79.2503 123.165 79.3339 123.173 79.4165C123.182 79.4992 123.207 79.5793 123.248 79.6513C123.289 79.7237 123.345 79.786 123.412 79.8348C123.512 79.9071 123.633 79.9459 123.756 79.9456C123.836 79.9456 123.916 79.929 123.989 79.8965C124.063 79.8642 124.129 79.8166 124.184 79.7572L127.687 76.0171"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M131.09 73.4251C131.09 73.4251 131.707 72.648 131.216 72.0751C131.142 71.993 131.057 71.9226 130.963 71.865C130.757 71.7338 130.521 71.659 130.278 71.6477C129.899 71.6702 129.532 71.7886 129.21 71.9915C128.888 72.1947 128.622 72.4761 128.436 72.8099"
          stroke="#006B99"
          strokeWidth="3.23435"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_1234">
          <rect width="300" height="201" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BlueSvg;
